// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC8_FecIX4SFUjbOxZ1_uv6gsUFQxEiHJo",
  authDomain: "test-seriesprepxpathshala.firebaseapp.com",
  projectId: "test-seriesprepxpathshala",
  storageBucket: "test-seriesprepxpathshala.firebasestorage.app",
  messagingSenderId: "357940387365",
  appId: "1:357940387365:web:b2655f069d150352e8e9cc",
  measurementId: "G-FT4CZD2LH4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const firebaseApp = app;

const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const analytics = getAnalytics(app);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");
export { auth, googleProvider };
